import { useState, useEffect, useCallback } from "react";

import "../common/Util.css";
import "./stops-list.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import CommonSnackbar, { CommonPagination } from "../common/reusable-commponent";
import SearchableDropdown from "../common/commonDropDown";

import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";

import { format } from "date-fns";
import { getStopsListApi, deleteStopsApi, downloadStopTemplateApi, downloadBase64File } from "./stops-api";
import { useGlobal } from "../../GlobalContext";
import profileIcon from "../../assets/png/profile-ic.png";
import emailIcon from "../../assets/svg/email_ic.svg";
import phoneIcon from "../../assets/svg/phone_ic.svg";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";

import customerIcon from "../../assets/svg/customer_active_ic.svg";
import StopsExcelUploadModal from "./stops-excel-upload-model";
import dateIcon from "../../assets/svg/date_ic.svg";
import ProfileImageModal from "../common/ProfileImageModal";
import "../common/skeleton-effect.css";
import { sanitizeInput, validateUrl } from "../common/security-utils";

const SORT_BY_OPTIONS = [
  { value: "created asc", label: "Created (Oldest)" },
  { value: "created desc", label: "Created (Newest)" },
  { value: "updated asc", label: "Updated Date (Oldest)" },
  { value: "updated desc", label: "Updated Date (Newest)" },
];

export const StopListing = () => {
  const { rolePermissionList = [] } = useGlobal();
  function checkPermission(permission) {
    if (!rolePermissionList || !Array.isArray(rolePermissionList)) return false;
    return rolePermissionList.findIndex((element) => element?.["name"] === "Stops" && element?.["menu_permission"] === true && element[permission] === true) > -1;
  }
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;

  // variable initial
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState(SORT_BY_OPTIONS[1]);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [active, setActive] = useState("grid");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stopsList, setStopsList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  // handle

  const [customerSelect, setCustomerSelect] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState(null);
  const handleSelectCustomer = (option) => {
    setCustomerSelect(option);
  };
  const handleClearCustomer = () => {
    setCustomerSelect(null);
  };

  const handleSelectLocation = (option) => {
    setLocationSelect(option);
  };
  const handleClearLocation = () => {
    setLocationSelect(null);
  };

  const handleSelectStatus = (option) => {
    setStatusSelect(option);
  };

  const handleClearStatus = () => {
    setStatusSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  // useEffect

  useEffect(() => {
    getStopsList();
  }, [itemsPerPage, itemOffset, search, selectedSortby, statusSelect, customerSelect, locationSelect, startDateSave, endDateSave]);

  // Api

  const getStopsList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: sanitizeInput(search),
      status: statusSelect?.value ?? "",
      customer_id: customerSelect?.value ?? "",
      location_id: locationSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getStopsListApi(param);
      if (response?.data?.success === true) {
        setTotalCount(response.data.totalcount ?? 0);
        setPageCount(response.data.totalpages ?? 0);
        setStopsList(response.data.stops ?? []);
      } else if (response?.data?.success === false) {
        setSnackbarMessage(response.data.message || "Failed to fetch stops");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      setSnackbarMessage("An error occurred while fetching stops.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    setIsLoading(true);
    try {
      const response = await deleteStopsApi(deleteId);
      if (response?.data?.success === true) {
        getStopsList();
        setSnackbarMessage(response.data.message || "Stop deleted successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        setSnackbarMessage(response?.data?.message || "Failed to delete stop");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      setSnackbarMessage("An error occurred while deleting the stop.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setIsLoading(true);
    try {
      const res = await downloadStopTemplateApi();

      if (!res || !res.data) {
        throw new Error("No response from server");
      }

      if (res.data.success === false) {
        setSnackbarMessage(res.data.message || "Failed to download template");
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      let filename = "stops_template_" + new Date().toISOString() + ".xlsx";

      downloadBase64File(res.data.base64, filename);

      setSnackbarMessage("Template downloaded successfully");
      setSnackbarStatus(true);
      handleSnackbarShow();
    } catch (err) {
      setSnackbarMessage(err.message || "Error downloading template");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <StopsExcelUploadModal
        type={"Stop"}
        show={showExcelUploadModal}
        onHide={() => setShowExcelUploadModal(false)}
        onUploadSuccess={() => {
          setItemOffset(0);
          getStopsList();
          setSnackbarMessage("Stops imported successfully");
          setSnackbarStatus(true);
          handleSnackbarShow();
        }}
      />
      <DeleteModal
        title={"stops"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteVendor}
      />
      <>
        <div className="my-2">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="stops-header-title fs-24 fw-600">
              Stops : {totalCount}
            </div>

            <div className="d-flex flex-wrap gap-3">
              <div className="stops-search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                <SearchIc />
                <input
                  type="text"
                  placeholder="Search"
                  className="stops-search-input rounded-3 fs-14 fw-500 textcolor"
                  value={search || ""}
                  onChange={(e) => setSearch(sanitizeInput(e.target.value))}
                />
              </div>

              {checkPermission("create_permission") && (
                <div
                  className="cursor-pointer add-new add-stop-btn d-flex align-items-center justify-content-center gap-2  px-3"
                  onClick={() => navigate("/stops/create")}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                  </div>

                  <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                    New Stop
                  </div>
                </div>
              )}

              <div className="cursor-pointer d-flex align-items-center justify-content-center gap-2 px-3" style={{ height: "40px" }}>
                {checkPermission("create_permission") && (
                  <div
                    className="cursor-pointer add-new template-btn d-flex align-items-center justify-content-center gap-2 px-3"
                    onClick={handleDownloadTemplate}
                  >
                    <DownloadIc />
                    <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                      Template
                    </div>
                  </div>
                )}

                {checkPermission("create_permission") && (
                  <div
                    className="cursor-pointer add-new import-btn d-flex align-items-center justify-content-center gap-2 px-3"
                    onClick={() => setShowExcelUploadModal(true)}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ImportIc />
                    </div>
                    <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                      Import
                    </div>
                  </div>
                )}
              </div>

              {/* Import */}
              {/* <div className="my-import d-flex align-items-center justify-content-center gap-2">
                  <ImportIc />
                  <div style={{ paddingBottom: "4px" }}>Import</div>
                </div> */}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-wrap justify-content-start gap-2">
              <div onClick={(e) => e.stopPropagation()}>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-sort"
                    className="sort-dropdown-toggle d-flex align-items-center justify-content-between"
                    title={selectedSortby.label}
                  >
                    {/* Left: "Sort by" label */}
                    <span className="fs-12 fw-400 textGrey">Sort by :</span>

                    {/* Right: Selected + arrow */}
                    <span className="d-flex align-items-center px-1">
                      <span className="dropdown-text">{selectedSortby.label}</span>
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="sort-dropdown-menu">
                    {SORT_BY_OPTIONS.map((option) => (
                      <Dropdown.Item
                        className="fs-14 fw-500 textcolor"
                        key={option.value}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSortBy(option);
                        }}
                        active={selectedSortby.value === option.value}
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <SearchableDropdown apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Customer" value={customerSelect} onSelect={handleSelectCustomer} handleClear={handleClearCustomer} />
              </div>
              <div>
                <SearchableDropdown apiUrl={`${apiUrl}get_locations`} placeholder="Location" value={locationSelect} onSelect={handleSelectLocation} handleClear={handleClearLocation} />
              </div>
              <div>
                <SearchableDropdown apiUrl={`${apiUrl}stops/status`} placeholder="Status" value={statusSelect} onSelect={handleSelectStatus} handleClear={handleClearStatus} />
              </div>

              <div className="date-range-filter-wrapper d-flex align-items-center px-1">
                <span className="fs-12 fw-400 textGrey">Date :</span>
                <span className="dropdown-text1 ps-1 pb-1">
                  {" "}
                  <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} style={{ border: "none", padding: "0", backgroundColor: "transparent" }} />
                </span>
              </div>
              <div
                className="cursor-pointer ms-1 fs-12 fw-400 reset-filters-btn d-flex align-items-center justify-content-center"
                onClick={() => {
                  setCustomerSelect(null);
                  setLocationSelect(null);
                  setStatusSelect(null);
                  setStartDateSave(null);
                  setEndDateSave(null);
                  setStartDate(null);
                  setEndDate(null);
                }}
              >
                Reset Filters
              </div>
            </div>

            <div className="rounded-3 view-toggle-wrapper d-flex mt-2">
              {/*  Excel upload */}
              <div
                onClick={() => setActive("list")}
                className={`d-flex align-items-center justify-content-center rounded-3 view-toggle-item ${active === "list" ? "bg-primary1" : ""}`}
              >
                {active === "list" ? <ListView style={iconStyle} /> : <SelectList style={iconStyle} />}
              </div>

              <div
                onClick={() => setActive("grid")}
                className={`d-flex align-items-center justify-content-center rounded-3 view-toggle-item ${active === "grid" ? "bg-primary1" : ""}`}
              >
                {active === "grid" ? <SelectGrid style={iconStyle} /> : <EmailView style={iconStyle} />}
              </div>
            </div>
          </div>
        </div>
        {active === "list" && (
          <div className="bg-white rounded-4 w-100 p-3">
            <div className="stops-table-header w-100 justify-content-center align-items-center">
              {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                CODE
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                CUSTOMER NAME
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                MOBILE NO.
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                EMAIL
              </p>{" "}
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                FROM ADDRESS
              </p>{" "}
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                TO ADDRESS
              </p>{" "}
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                DATE
              </p>{" "}
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                Status
              </p>{" "}
            </div>
            <div>
              <div>
                {isLoading
                  ? // Skeleton rows for list view
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      className="stops-table-row w-100 justify-content-center align-items-center"
                    >
                      {Array.from({ length: 8 }).map((_, colIdx) => (
                        <div key={colIdx} style={{ flex: "1" }} className="mt-3">
                          <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                        </div>
                      ))}
                    </div>
                  ))
                  : (stopsList ?? []).map((item, index) => (
                    <div
                      key={item.id ?? index}
                      className={`stops-table-row w-100 justify-content-center align-items-center ${hoveredIndex === index ? "hovered" : ""}`}
                      onClick={() => {
                        if (checkPermission("view_permission")) {
                          navigate("/stops/view", { state: { id: item.id } });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.stop_code}
                      >
                        {item.stop_code ?? "---"}
                      </p>
                      {/* CUSTOMER NAME */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.customer_name}
                      >
                        {item.customer_name ?? "---"}
                      </p>

                      {/* MOBILE */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.mobilenumber}
                      >
                        {item.mobilenumber ?? "---"}
                      </p>

                      {/* EMAIL */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.email}
                      >
                        {item.email ?? "---"}
                      </p>

                      {/* FROM ADDRESS */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.from_address}
                      >
                        {item.from_address ?? "---"}
                      </p>

                      {/* TO ADDRESS */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.to_address}
                      >
                        {item.to_address ?? "-"}
                      </p>

                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.created_date}
                      >
                        {item.created_date ?? "-"}
                      </p>

                      {/* STATUS */}
                      <p
                        className="fs-13 fw-500 textcolor stops-table-cell"
                        title={item.status}
                      >
                        <span className="status-dot"></span>
                        {item.status ?? "---"}
                      </p>

                      {/* ACTION BUTTONS ON HOVER */}
                      {hoveredIndex === index && (
                        <div className="stops-action-btns-overlay">
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {/* EDIT */}
                            {checkPermission("edit_permission") && item.status === "Created" && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/stops/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                className="action-icon-circle-btn"
                              >
                                <img src={editIcon} alt="edit" />
                              </div>
                            )}

                            {/* DELETE */}
                            {checkPermission("delete_permission") && item.status === "Created" && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                className="action-icon-circle-btn ms-2"
                              >
                                <img src={deleteIcon} alt="delete" />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {active === "grid" && (
          <>
            {isLoading
              ? // Skeleton cards for grid view
              Array.from({ length: 5 }).map((_, idx) => (
                <div key={idx} className="bg-white rounded-4 d-flex align-items-center justify-content-between business-card w-100 p-3 mb-3">
                  <div className="d-flex col-3">
                    <div className="skeleton" style={{ width: "56px", height: "48px", borderRadius: "50%" }} />
                    <div className="d-flex flex-column align-items-start justify-content-center gap-2 ps-3">
                      <div className="skeleton skeleton-text" style={{ width: "120px", height: "16px" }} />
                      <div className="skeleton skeleton-text" style={{ width: "100px", height: "14px" }} />
                    </div>
                  </div>
                  <div style={{ height: "28px", width: "1px", backgroundColor: "#EBEBEB" }}></div>
                  <div className="col-2 ps-3 d-flex flex-column align-items-start gap-2">
                    <div className="skeleton skeleton-text" style={{ width: "140px", height: "14px" }} />
                    <div className="skeleton skeleton-text" style={{ width: "160px", height: "14px" }} />
                    <div className="skeleton skeleton-text" style={{ width: "120px", height: "14px" }} />
                  </div>
                  <div style={{ height: "28px", width: "1px", backgroundColor: "#EBEBEB" }}></div>
                  <div className="col-4 ms-3 d-flex flex-column align-items-start gap-2">
                    <div className="skeleton skeleton-text" style={{ width: "200px", height: "14px" }} />
                    <div className="skeleton skeleton-text" style={{ width: "200px", height: "14px" }} />
                  </div>
                  <div className="col-2 d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3 pe-2">
                    <div className="skeleton" style={{ width: "100px", height: "36px", borderRadius: "18px" }} />
                  </div>
                </div>
              ))
              : stopsList.map((stop, index) => (
                <div
                  key={index}
                  className="bg-white rounded-4  d-flex align-items-center justify-content-between   business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/stops/view", {
                        state: { id: stop.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex col-3">
                    <div
                      className="profile-wrapper"
                      onClick={(e) => {
                        e.stopPropagation();
                        const profileUrl = stop.profile && stop.profile !== "" ? stop.profile : customerIcon;
                        // Only set profile if it's a valid URL, a local svg import path/data URL, or fallback to default
                        const isSafeUrl = validateUrl(profileUrl) || profileUrl.startsWith("data:") || profileUrl.startsWith("/") || profileUrl === customerIcon;
                        setSelectedProfile(isSafeUrl ? profileUrl : customerIcon);
                        setShowProfilePopup(true);
                      }}
                    >
                      <img key={index} src={stop.profile && stop.profile !== "" ? stop.profile : customerIcon} alt="Profile" className="profile-img" />{" "}
                    </div>
                    <div className="d-flex flex-column align-items-start justify-content-center gap-2 ps-3">
                      <div className="textcolor fs-16 fw-600 ">{stop.stop_code ?? "-"}</div>
                      <div className="textcolor fs-14 fw-600 ">{stop.customer_name ?? "-"}</div>
                    </div>
                  </div>
                  <div className="vertical-divider"></div>
                  <div className="col-2 ps-3  d-flex flex-column align-items-start">
                    {/*  <div className="fs-12 fw-600 cardTextGrey">MOBILE NO.</div> */}
                    {stop.mobilenumber !== null && stop.mobilenumber !== "" && (
                      <div className="fs-14 fw-400 textcolor mt-1 d-flex align-items-center justify-content-start">
                        <img src={phoneIcon} alt="phone" /> <span className="ms-1">{stop.mobilenumber ?? "-"}</span>
                      </div>
                    )}
                    {stop.email !== null && stop.email !== "" && (
                      <div className="mt-2 d-flex gap-2  align-items-center">
                        <img src={emailIcon} alt="email" /> <span className="textcolor fs-14 fw-400">{stop.email ?? "-"}</span>{" "}
                      </div>
                    )}
                    <div className="mt-2 fs-14 fw-400 textcolor mt-1 d-flex align-items-center justify-content-start">
                      <img src={dateIcon} alt="date" /> <span className="ms-1">{stop.created_date ?? "-"}</span>
                    </div>
                  </div>
                  <div className="vertical-divider"></div>
                  <div className="col-4 ms-3 d-flex flex-column align-items-start ">
                    <div className="fs-12 fw-600 cardTextGrey d-flex">
                      <div className="card-label-fixed"> FROM : </div>
                      <span className="fs-14 fw-400 textcolor text-start">
                        {stop.from_address ?? ""}
                      </span>
                    </div>
                    <div className="fs-12 fw-600 cardTextGrey mt-1 d-flex">
                      <div className="card-label-fixed"> TO : </div>
                      <span className="fs-14 fw-400 textcolor text-start">
                        {stop.to_address ?? ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-2 d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  pe-2">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          bsPrefix="custom-toggle"
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5 stop-grid-status-toggle"
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span className="backgroundYellow status-dot"></span>

                            <span className="dropdown-text textcolor fs-13 fw-500">{stop.status ?? "-"}</span>

                            {/* <span className="dropdown-toggle-arrow"></span> */}
                          </span>
                        </Dropdown.Toggle>

                        {/* <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {stageListOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option}
                              onClick={() =>
                                updateStage(stop.id, option.value)
                              }
                              // active={selected === option}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu> */}
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") || checkPermission("delete_permission")) && stop.status === "Created" && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between rounded-5 stop-grid-more-toggle bg-white"
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="stop-grid-more-menu">
                            {checkPermission("edit_permission") && stop.status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/stops/create", {
                                    state: { id: stop.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && stop.status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(stop.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}
        <CommonPagination
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          pageCount={pageCount + 1}
          onPageChange={handlePageClick}
          forcePage={itemOffset}
        />
      </>
      <CommonSnackbar
        show={showSnackbar}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        isSuccess={snackbarStatus === true}
      />

      {/* Profile Image Modal */}
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} />
    </>
  );
};
